import { render, staticRenderFns } from "./PbcCtaHelp.vue?vue&type=template&id=8e8edfea&"
import script from "./PbcCtaHelp.vue?vue&type=script&lang=js&"
export * from "./PbcCtaHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports